export const TEXT = {
    Age: {en: "Age", ar: "العمر"},
    TextField: { en: "Text", ar: "نص" },
    NumberField: { en: "Number", ar: "رقم" },
    ImagePicker: { en: "Upload Image", ar: "تحميل صورة" },
    ProfileImagePicker: { en: "Upload Profile Image", ar: "تحميل صورة الملف الشخصي" },
    BirthdatePicker: { en: "Birthdate", ar: "تاريخ الميلاد" },
    Email: { en: "Email", ar: "البريد الإلكتروني" },
    PhoneNumber: { en: "Phone Number", ar: "رقم الهاتف" },
    MapAddress: { en: "Map Address", ar: "العنوان في الخريطة" },
    NameField: { en: "Name", ar: "الاسم" },
    Autocomplete: { en: "Autocomplete", ar: "الإكمال التلقائي" },
    InvalidPhoneNumber: { en: "Invalid phone number , enter digit only", ar: " رقم هاتف غير صالح مسموح بالارقام فقط" },
    InvalidEmail: { en: "Invalid email address", ar: "عنوان بريد إلكتروني غير صالح" },
    InvalidNumber: { en: "Invalid number", ar: "رقم غير صالح" },
    InvalidName: { en: "Invalid name , latters are only allowed", ar: "اسم غير صالح مسموح بالحروف فقط" },
    InvalidGeoLocation : { en: "Invalid location , please select a location from the map", ar: "موقع غير صالح ، يرجى تحديد موقع من الخريطة" },
};
export default TEXT;